import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { nullsafe, contains, toObservable } from "keautils";

import { DireccionClienteSelectorView } from "./direccionView";
import { Contacto } from "app/features/selectores/items/contacto";
import { observeResource } from "kea-resource";

type Entity = models.ClienteDireccionContactoDTO;

interface Props {
    value?: number;
    onChange: (x: number | undefined) => void;
    /**Filtro para los clientes */
    filtroCliente?: models.FiltroCliente;
    idSucursalUsuario?: number;
    /**Indica que se aplicará el permiso de documentar de cualquier origen */    
    filtrarDireccionesPermiso?: boolean;
}
interface State {
    idDireccion?: number;
    Telefono?: string;
    Email?: string;
}

/**Selector de un contacto de una dirección de un cliente. El value es el IdContactoCliente */
export class ContactoClienteSelectorView extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    private idSucursalUsuario = (state: State, props: Props) => props.idSucursalUsuario;
    private filtrarDireccionesPermiso = (state: State, props: Props) => props.filtrarDireccionesPermiso;

    private idContacto = (state: State, props: Props) => props.value;
    private contacto = createSelectorRx(this.idContacto, id => toObservable(nullsafe(id, id => observeResource(resources.ContactoCliente.Get, id))));

    private idDireccionFromValue = createSelectorRx(this.contacto, contacto => nullsafe(contacto, x => x.IdDireccionCliente));
    private idDireccionFromState = (state: State, props: Props) => state.idDireccion;

    //NOTA: Le damos prioridad al NULL sobre el UNDEFINED, esto por que un NULL indica una limpieza por parte del usuario, en cambio un undefined indica que el valor no se conoce
    private idDireccion = createSelectorRx(this.idDireccionFromValue, this.idDireccionFromState, async (val, state) => val === null ? null : (state || val));

    private value = (state: State, props: Props) => props.value;

    private handleOnDireccion = (idDireccion: number) => {
        this.setState({ idDireccion: idDireccion });
        this.props.onChange(undefined);
    }

    private handleOnContacto = async (id: number) => {
        //Establecer el ID
        this.props.onChange(id);
    }

    getField = formfields(() => this.props);

    render() {
        const idDireccion = this.idDireccion(this.state, this.props);
        const idSucursalUsuario = this.idSucursalUsuario(this.state, this.props);
        const filtrarDireccionesPermiso = this.filtrarDireccionesPermiso(this.state, this.props);
        const Text = this.getField(kea.Text);
        return (
            kea.autogrid(12, [
                <DireccionClienteSelectorView value={idDireccion} onChange={this.handleOnDireccion} filtroCliente={this.props.filtroCliente} idSucursalUsuario={idSucursalUsuario} filtrarDireccionesPermiso={filtrarDireccionesPermiso} />,
                <Contacto value={this.props.value} onChange={this.handleOnContacto} idDireccion={idDireccion} />,
            ])
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/selectores/items/direccioncliente/contactoview.tsx